export default __webpack_public_path__ + "static/media/Tiger's Leggings of the Untamed.dcd5a0e7.jpg";